import React, { forwardRef } from 'react';
import { Typography, TypographyProps, TokenColor } from './Typography';

type Props = Omit<TypographyProps, 'variant' | 'color'> & { color?: TokenColor };

export const Display = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <Typography {...props} ref={ref} variant="display" />
));

export const Heading = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <Typography {...props} ref={ref} variant="heading" />
));

export const Title = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <Typography {...props} ref={ref} variant="title" />
));

export const Body = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <Typography {...props} ref={ref} variant="body" />
));

export const Label = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <Typography {...props} ref={ref} variant="label" />
));
